/* Shared presentation and quantity selection. Native Shopify/Tee controls own purchase and personalization. */
(() => {
  'use strict';
  function initialize() {
    const dataNode = document.getElementById('npu-product-data');
    if (!document.body.classList.contains('npu') || !dataNode || dataNode.dataset.bound) return;
    const requestedView = new URL(location.href).searchParams.get('view');
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch { return; }
    dataNode.dataset.bound = 'true';
    const section = document.querySelector('[id^="MainProduct-"]');
    if (!section) return;
    const abort = new AbortController();
    const format = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: data.currency || 'USD' });
    const form = () => section.querySelector('product-form.main-product-form form[action*="/cart/add"]');
    const quantity = () => form()?.querySelector('input[name="quantity"]') || section.querySelector('input[name="quantity"][form]');
    const variant = () => data.variants.find(item => String(item.id) === form()?.querySelector('input[name="id"]')?.value);
    const percentFor = count => (data.discountTiers || []).filter(tier => count >= tier.min).sort((a, b) => b.min - a.min)[0]?.percent || 0;
    // Native gift-set discounts round the per-piece discount down to whole cents.
    const packPrice = (price, count) => (price - Math.floor(price * percentFor(count) / 100)) * count;
    let frame = 0;
    let lastAnnounced = '';
    const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
    function preserveProductView() {
      const url = new URL(location.href);
      if (requestedView && url.searchParams.get('view') !== requestedView) {
        url.searchParams.set('view', requestedView);
        history.replaceState(history.state, '', url.href);
      }
    }

    function setQuantity(value) {
      const input = quantity();
      const current = variant();
      if (!input || !current) return;
      const min = Number(current.min) || 1;
      const step = Number(current.step) || 1;
      const max = Number(current.max) || Infinity;
      const next = Math.max(min, Math.min(max, min + Math.round((Number(value) - min) / step) * step));
      if (String(next) !== input.value) {
        input.value = String(next);
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
      schedule();
    }

    function syncBundle() {
      const bundle = document.querySelector('[data-npu-bundle]');
      const atc = form()?.querySelector('button[type="submit"][name="add"]');
      if (!bundle || !atc) return;
      const anchor = atc.closest('.np-bakven-purchase-row') || atc;
      if (anchor.previousElementSibling !== bundle) anchor.before(bundle);
      const current = variant();
      if (!current) return;
      const count = Number(quantity()?.value) || Number(current.min) || 1;
      const min = Number(current.min) || 1;
      const step = Number(current.step) || 1;
      const max = Number(current.max) || Infinity;
      for (const radio of bundle.querySelectorAll('[data-npu-pack]')) {
        const pack = Number(radio.value);
        radio.checked = pack === count;
        radio.disabled = !current.available || pack < min || pack > max || (pack - min) % step !== 0;
        setText(bundle.querySelector(`[data-npu-pack-price="${pack}"]`), format.format(packPrice(current.price, pack) / 100));
        const percent = percentFor(pack);
        setText(bundle.querySelector(`[data-npu-pack-caption="${pack}"]`), `${pack} ${pack === 1 ? 'piece' : 'pieces'}${percent ? ` · Save ${percent}%` : ''}`);
      }
      const gift = document.querySelector('[data-np-gift-box]');
      const giftQuantity = gift?.querySelector('[data-gift-check]')?.checked ? Number(gift.querySelector('[data-gift-quantity]')?.value) || 1 : 0;
      const giftTotal = giftQuantity * (Number(gift?.dataset.price) || 0);
      const total = format.format((packPrice(current.price, count) + giftTotal) / 100);
      const offerNote = bundle.querySelector('[data-npu-offer-note]');
      if (offerNote) {
        const tiers = (data.discountTiers || []).filter(tier => tier.percent > 0);
        offerNote.hidden = !tiers.length;
        setText(offerNote, tiers.length ? `Gift set savings: ${tiers.map(tier => `${tier.percent}% off ${tier.min}${tier.min === 3 ? '+' : ''} pieces`).join(' · ')}. Offers may not combine. Final savings appear in your bag.` : '');
      }
      setText(bundle.querySelector('[data-npu-selection]'), `${count} ${count === 1 ? 'piece' : 'pieces'}${giftQuantity ? ` + ${giftQuantity} gift ${giftQuantity === 1 ? 'box' : 'boxes'}` : ''}`);
      setText(bundle.querySelector('[data-npu-total]'), total);
      const announcement = `${count} ${count === 1 ? 'piece' : 'pieces'}, ${total}. Same personalization on every piece.`;
      if (lastAnnounced && lastAnnounced !== announcement) setText(bundle.querySelector('[data-npu-status]'), announcement);
      lastAnnounced = announcement;
      for (const input of document.querySelectorAll('[data-npu-preview-quantity]')) {
        if (input !== document.activeElement) input.value = String(count);
        input.min = String(min);
        input.step = String(step);
        if (Number.isFinite(max)) input.max = String(max); else input.removeAttribute('max');
      }
    }

    function prepareFields() {
      for (const field of section.querySelectorAll('#teeFormInputs .tee-field')) {
        const heading = field.querySelector('.tee-field__heading');
        if (!heading) continue;
        const group = field.querySelector('[role="radiogroup"]');
        const headingId = group?.getAttribute('aria-labelledby') || `npu-heading-${field.id}`;
        if (!document.getElementById(headingId)) heading.id = headingId;
        for (const input of field.querySelectorAll('input[type="text"], textarea, select')) {
          if (!input.hasAttribute('aria-labelledby')) input.setAttribute('aria-labelledby', heading.id || headingId);
        }
      }
    }

    function preparePreview() {
      const atc = document.getElementById('preview-teeAtcButton');
      const footer = atc?.closest('.tee-dcontent-footer');
      if (!footer) return;
      const modal = footer.closest('.vm--modal');
      const headings = modal?.querySelectorAll('.np-bakven-preview-title, .npu-preview-title');
      let heading = headings?.[0];
      for (const duplicate of Array.from(headings || []).slice(1)) duplicate.remove();
      if (!heading && modal) {
        heading = document.createElement('h3');
        heading.className = 'npu-preview-title';
        modal.querySelector('.tee-dcontent-body')?.before(heading);
      }
      setText(heading, 'Your gift, made personal');
      // The sculpture adapter owns its preview quantity control.
      if (document.body.classList.contains('np-bakven-product')) {
        footer.querySelector('[data-npu-preview-control]')?.remove();
        return;
      }
      if (footer.querySelector('[data-npu-preview-control]')) return;
      const input = quantity();
      if (!input) return;
      const control = document.createElement('label');
      control.className = 'npu-preview-quantity';
      control.dataset.npuPreviewControl = '';
      const text = document.createElement('span');
      text.textContent = 'Quantity';
      const number = document.createElement('input');
      number.type = 'number';
      number.min = input.min || '1';
      number.step = input.step || '1';
      number.value = input.value;
      number.dataset.npuPreviewQuantity = '';
      number.addEventListener('input', () => {
        if (number.value !== '' && number.validity.valid) setQuantity(number.value);
      }, { signal: abort.signal });
      number.addEventListener('change', () => setQuantity(number.value), { signal: abort.signal });
      control.append(text, number);
      footer.prepend(control);
    }

    function refresh() { preserveProductView(); syncBundle(); prepareFields(); preparePreview(); }
    function schedule() { if (!frame) frame = requestAnimationFrame(() => { frame = 0; refresh(); }); }
    document.addEventListener('change', event => {
      if (!(event.target instanceof Element)) return;
      if (event.target.matches('[data-npu-pack]')) setQuantity(event.target.value);
      if (event.target.closest('[id^="MainProduct-"], .vm--modal')) schedule();
    }, { signal: abort.signal });
    document.addEventListener('np:gift-box-change', schedule, { signal: abort.signal });
    section.addEventListener('input', schedule, { signal: abort.signal });
    window.addEventListener('popstate', preserveProductView, { signal: abort.signal });
    document.addEventListener('click', event => {
      if (event.target instanceof Element && event.target.closest('.tee-btn--preview, .np-bakven-preview-quantity')) schedule();
    }, { signal: abort.signal });
    const observer = new MutationObserver(schedule);
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pagehide', () => { abort.abort(); observer.disconnect(); cancelAnimationFrame(frame); }, { once: true });
    refresh();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
})();
